import { Card, Flex, StepProps, Steps, Typography } from "antd";

import { observer } from "mobx-react-lite";

import { ReactComponent as Checkmark } from "../../images/Steps/checkmark-on-circle.svg";
import { ReactComponent as CheckmarkDark } from "../../images/Steps/checkmark-on-circle_dark.svg";
import { ReactComponent as CheckmarkEmpty } from "../../images/Steps/check_circle.svg";

import styles from "./steps.module.css";
import { Link } from "react-router-dom";
import { routes } from "constants/routes";
import { DIRECT_PAYMENT_CUSTOMER_LP, QUOTE_SELECTION } from "utils/envConstants";
import { BidRequestStatus, QUOTE_SELECTION_ENUM } from "interfaces";

interface CardStepsProps {
  items: (StepProps & {
    rawStatus?: BidRequestStatus | string;
    date?: string;
    initiator?: { id: string; fullName: string };
  })[];
  currentIndex: number;
  currentStatus?: BidRequestStatus | string;
  className?: string;
}

interface SubStepsProps {
  items: (StepProps & {
    checked: boolean;
    tooltipHistory?: {
      date?: string;
      userName?: string;
      userId?: string;
    };
  })[];
}
const isQuoteStepToHide = QUOTE_SELECTION === QUOTE_SELECTION_ENUM.CUSTOMER;

export const CardSteps = observer(({ items, currentIndex, currentStatus, className }: CardStepsProps) => {
  const visibleItems = items.filter((item) => !(isQuoteStepToHide && item.title === "Котировка предложена"));
  const statusIndex =
    currentStatus != null ? visibleItems.findLastIndex((item) => item.rawStatus === currentStatus) : -1;
  const visibleCurrentIndex =
    statusIndex >= 0
      ? statusIndex
      : currentIndex >= 0 && currentIndex < visibleItems.length
        ? currentIndex
        : Math.max(0, visibleItems.length - 1);

  const updatedItems = visibleItems.map((item, index) => {
    const { rawStatus: _rawStatus, ...stepItem } = item;
    return {
      ...stepItem,
      title: (
        <Typography.Text
          strong={index === visibleCurrentIndex}
          className={`${styles.stepTitle} ${index === visibleCurrentIndex ? styles.stepTitleActive : ""}`}
        >
          {item.title}
        </Typography.Text>
      ),
      description:
        item.date || item.description ? (
          <Flex vertical gap="small">
            {item.description ? item.description : null}
          </Flex>
        ) : undefined,
      icon:
        index < visibleCurrentIndex ? (
          <Checkmark />
        ) : index === visibleCurrentIndex ? (
          <CheckmarkDark />
        ) : (
          <CheckmarkEmpty />
        ),
    };
  });

  return (
    <Card className={className} bordered={false}>
      <Steps
        direction="vertical"
        current={visibleCurrentIndex}
        status={visibleCurrentIndex === visibleItems.length - 1 ? "finish" : "process"}
        size="small"
        items={updatedItems}
        key={visibleCurrentIndex}
      />
    </Card>
  );
});

export const SubSteps = observer(({ items }: SubStepsProps) => {
  const updatedItems = items.map((item, index) => {
    const { tooltipHistory, ...restItem } = item;
    return {
      ...restItem,
      title: (
        <Flex vertical>
          <Typography.Text className={styles.stepTitle}>{item.title}</Typography.Text>
          {tooltipHistory?.date ? (
            <Flex gap="small" align="center" style={{ height: `${!tooltipHistory?.userName ? "26px" : undefined}` }}>
              <Typography.Text className={styles.stepDate}>{tooltipHistory?.date}</Typography.Text>
              {tooltipHistory?.userName && (
                <Link
                  to={`/${routes.users}/${tooltipHistory?.userId}`}
                  className={`${styles.userInfo} hover-underline`}
                >
                  {tooltipHistory?.userName && (
                    <Typography.Text className={styles.stepUserName}>({tooltipHistory?.userName})</Typography.Text>
                  )}
                </Link>
              )}
            </Flex>
          ) : null}
        </Flex>
      ),
      icon: item.checked ? <CheckmarkDark /> : <CheckmarkEmpty />,
    };
  });

  return <Steps direction="vertical" status="process" size="small" items={updatedItems} className={styles.subSteps} />;
});
